import styled from 'styled-components'

export const Container = styled.div`
  height: calc(100% - 58px);
  overflow-y: scroll;
`
